import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import ByzMuiTypography from "../../inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

interface ByzMuiCloseButtonProps {
  onClick: () => void;
}

const StyledCloseButton = styled(Button)(() => ({
  padding: "4px 20px",
  gap: "6px",
  border: "1px solid #B71C1C",
  backgroundColor: "#B71C1C",
  color: "white",
  opacity: 1,
  borderRadius: "4px",
  boxShadow:
    "0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 2px 4px -1px rgba(0, 0, 0, 0.20)",
  transition: "background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "#AE4242",
    boxShadow:
      "0 2px 12px 0 rgba(0, 0, 0, 0.15), 0 6px 6px 0 rgba(0, 0, 0, 0.18), 0 3px 5px -1px rgba(0, 0, 0, 0.22)",
  },
}));

const ByzMuiCloseButton = ({ onClick }: ByzMuiCloseButtonProps) => {
  const { t } = useTranslate();

  return (
    <StyledCloseButton onClick={onClick}>
      <img
        src="/assets/icons/delete/deletex.svg"
        alt={t("buttons.close")}
        style={{ width: 16, height: 16, transition: "0.2s ease-in-out" }}
      />
      <ByzMuiTypography
        fontWeight={400}
        sx={{ alignItems: "center", justifyContent: "center" }}
      >
        {t("buttons.close", "uppercase")}
      </ByzMuiTypography>
    </StyledCloseButton>
  );
};

export default ByzMuiCloseButton;
